




























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Navbar extends Vue {
  public scrolled = false;

  mounted() {
    window.addEventListener('scroll', () => {
      this.scrolled = window.scrollY >= 60;
    });
  }
}
